/**
 * [ENG-5490] Normalize a microphone label for identity matching across
 * replugs. Windows exposes the same physical device under alias entries
 * (`Default - Foo`, `Communications - Foo`) whose deviceIds differ from the
 * concrete `Foo` entry, and deviceIds themselves can change when a device is
 * replugged into a different USB port — the label is the stable identity.
 *
 * Callers must treat an empty result as "no identity": pre-permission
 * enumeration returns blank labels, and matching on '' would match anything.
 */
export const normalizeMicrophoneLabel = (label: string): string =>
  label
    .replace(/^(Default|Communications) - /i, '')
    .trim()
    .toLowerCase();
